/**
 * Returns browser name
 * https://stackoverflow.com/questions/34142711/javascript-how-do-i-get-all-the-browsers-name
 */ export function detectBrowserName() {
    const nav = window.navigator, ua = window.navigator.userAgent.toLowerCase();
    // Detect browsers (only the ones that have some kind of quirk we need to work around)
    if (nav.appName.toLowerCase().indexOf('microsoft') !== -1 || nav.appName.toLowerCase().match(/trident/gi) !== null) return 'IE';
    if (ua.match(/chrome/gi) !== null) return 'Chrome';
    if (ua.match(/firefox/gi) !== null) return 'Firefox';
    if (ua.match(/safari/gi) !== null) return 'Safari';
    if (ua.match(/webkit/gi) !== null) return 'Webkit';
    if (ua.match(/gecko/gi) !== null) return 'Gecko';
    if (ua.match(/opera/gi) !== null) return 'Opera';
    if (ua.match(/ui-prober/gi) !== null) return 'Prober';
    // If any case miss we will return null
    return 'unknown';
}

//# sourceMappingURL=browser.js.map